/*
  pulsman-core.js
  El archivo principal del tema (shrine.null.js) esta vacio. Este archivo aporta lo que
  la tienda usa de el: agregar al carrito, cajon y pagina del carrito, cantidades, cupon,
  temporizador, variantes y las funciones globales que necesita secondary.js.
  Basado en el codigo de Dawn de Shopify.
*/

/* ---------- Funciones globales que secondary.js espera ---------- */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus) {
  elementToFocus = elementToFocus || container;
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = function (event) {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);
  if (elementToFocus && elementToFocus.focus) elementToFocus.focus();
}

function removeTrapFocus(elementToFocus) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus && elementToFocus.focus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  var openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  var summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(function (video) {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(function (video) {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('media-gallery video').forEach(function (video) {
    video.pause();
  });
}
window.pauseAllMedia = pauseAllMedia;

function debounce(fn, wait) {
  var t;
  return function () {
    var args = arguments;
    var self = this;
    clearTimeout(t);
    t = setTimeout(function () {
      fn.apply(self, args);
    }, wait);
  };
}

/* ---------- Carrito ---------- */
(function () {
  var TIMER_KEY = 'pulsman_cart_timer_end';
  var routes = window.routes || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = routes.cart_url || '/cart';
  var isCartPage = location.pathname.replace(/\/$/, '') === cartUrl.replace(/\/$/, '');

  function drawerEl() {
    return document.querySelector('cart-drawer');
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* Reemplaza el contenido del cajon sin perder el scroll ni el desplegable de dijes */
  function applyDrawer(html) {
    var drawer = drawerEl();
    if (!drawer || !html) return;
    var fresh = parse(html);
    var newDrawer = fresh.querySelector('cart-drawer');
    var newInner = fresh.querySelector('#CartDrawer');
    var inner = document.getElementById('CartDrawer');
    if (!newDrawer || !newInner || !inner) return;
    var body = inner.querySelector('.cart-drawer__body');
    var scroll = body ? body.scrollTop : 0;
    var offerWasOpen = !!inner.querySelector('.dije-offer__details[open]');
    inner.innerHTML = newInner.innerHTML;
    drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
    var newBody = inner.querySelector('.cart-drawer__body');
    if (newBody) newBody.scrollTop = scroll;
    var offer = inner.querySelector('.dije-offer__details');
    if (offer && offerWasOpen) offer.open = true;
    tickTimers();
  }

  function applyBubble(html) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !html) return;
    var fresh = parse(html);
    var section = fresh.querySelector('.shopify-section') || fresh.body;
    bubble.innerHTML = section.innerHTML;
  }

  /* En la pagina /cart se cambian todas las piezas leyendo la pagina de nuevo */
  function refreshCartPage() {
    return fetch(cartUrl + '?nc=' + Date.now())
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var fresh = parse(html);
        var items = document.querySelector('cart-items');
        var newItems = fresh.querySelector('cart-items');
        if (items && newItems) items.replaceWith(newItems);
        var footer = document.getElementById('main-cart-footer');
        var newFooter = fresh.getElementById('main-cart-footer');
        if (footer && newFooter) footer.replaceWith(newFooter);
        var extras = document.querySelector('[id^="shopify-section-"][id$="__cart_extras"]');
        var newExtras = fresh.querySelector('[id^="shopify-section-"][id$="__cart_extras"]');
        if (extras && newExtras) extras.innerHTML = newExtras.innerHTML;
        var bubble = document.getElementById('cart-icon-bubble');
        var newBubble = fresh.getElementById('cart-icon-bubble');
        if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
        var inner = document.getElementById('CartDrawer');
        var newInner = fresh.getElementById('CartDrawer');
        var drawer = drawerEl();
        var newDrawer = fresh.querySelector('cart-drawer');
        if (inner && newInner) inner.innerHTML = newInner.innerHTML;
        if (drawer && newDrawer) drawer.classList.toggle('is-empty', newDrawer.classList.contains('is-empty'));
        document.querySelectorAll('.critical-hidden').forEach(function (el) {
          el.classList.remove('critical-hidden');
        });
        tickTimers();
      });
  }

  function refreshCart() {
    if (isCartPage) return refreshCartPage();
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        applyDrawer(sections['cart-drawer']);
        applyBubble(sections['cart-icon-bubble']);
      });
  }
  window.refreshCartDrawer = refreshCart;

  /* ---------- Cajon ---------- */
  function openDrawer(triggeredBy) {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.activeElement = triggeredBy || document.activeElement;
    setTimeout(function () {
      drawer.classList.add('animate', 'active');
    });
    drawer.addEventListener(
      'transitionend',
      function () {
        var container = drawer.classList.contains('is-empty')
          ? drawer.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        var focusEl = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
        if (container) trapFocus(container, focusEl);
      },
      { once: true }
    );
    document.body.classList.add('overflow-hidden');
    tickTimers();
  }

  function closeDrawer() {
    var drawer = drawerEl();
    if (!drawer) return;
    drawer.classList.remove('active');
    removeTrapFocus(drawer.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  class CartDrawer extends HTMLElement {
    open(triggeredBy) {
      openDrawer(triggeredBy);
    }
    close() {
      closeDrawer();
    }
  }

  /* ---------- Temporizador: guarda la hora final para no reiniciarse al navegar ---------- */
  function tickTimers() {
    var timers = document.querySelectorAll('.cart-timer countdown-timer');
    if (!timers.length) return;
    var drawer = drawerEl();
    var hasItems = isCartPage ? !!document.querySelector('.cart-item') : drawer && !drawer.classList.contains('is-empty');
    var store = window.sessionStorage;
    var end = 0;
    try {
      if (!hasItems) store.removeItem(TIMER_KEY);
      end = parseInt(store.getItem(TIMER_KEY), 10) || 0;
    } catch (e) {}
    timers.forEach(function (el) {
      if (!el.minutesSpan || !el.secondsSpan) return;
      if (!el.pulsmanSeconds) el.pulsmanSeconds = parseInt(el.getAttribute('data-duration'), 10) + 1 || 600;
      if (hasItems && end <= Date.now()) {
        end = Date.now() + el.pulsmanSeconds * 1000;
        try {
          store.setItem(TIMER_KEY, String(end));
        } catch (e) {}
      }
      var left = hasItems ? Math.max(0, Math.ceil((end - Date.now()) / 1000)) : el.pulsmanSeconds;
      el.minutesSpan.textContent = String(Math.floor(left / 60)).padStart(2, '0');
      el.secondsSpan.textContent = String(left % 60).padStart(2, '0');
    });
  }
  setInterval(tickTimers, 1000);

  /* ---------- Cantidades y eliminar ---------- */
  function lineFrom(el) {
    var withIndex = el.closest('[data-index]');
    if (el.dataset && el.dataset.index) return parseInt(el.dataset.index, 10);
    if (withIndex) return parseInt(withIndex.dataset.index, 10);
    var byId = /(\d+)$/.exec(el.id || '');
    return byId ? parseInt(byId[1], 10) : 0;
  }

  function showLineError(scope, line, message) {
    var el =
      document.querySelector((scope === 'drawer' ? '#CartDrawer-LineItemError-' : '#Line-item-error-') + line) || null;
    if (!el) return;
    var text = el.querySelector('.cart-item__error-text');
    if (text) text.textContent = message;
  }

  var changing = false;
  function changeLine(line, quantity, scope) {
    if (!line || changing) return;
    changing = true;
    var row = document.querySelector((scope === 'drawer' ? '#CartDrawer-Item-' : '#CartItem-') + line);
    if (row) {
      row.querySelectorAll('.loading-overlay').forEach(function (o) {
        o.classList.remove('hidden');
      });
    }
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity }),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        return refreshCart().then(function () {
          if (!res.ok) {
            showLineError(scope, line, res.data.description || res.data.message || (window.cartStrings && cartStrings.error));
            return;
          }
          /* Shopify entrega menos de lo pedido cuando no hay inventario suficiente */
          var item = res.data.items && res.data.items[line - 1];
          if (quantity > 0 && item && item.quantity < quantity && window.cartStrings) {
            showLineError(scope, line, cartStrings.quantityError.replace('[quantity]', item.quantity));
          }
        });
      })
      .catch(function () {
        showLineError(scope, line, window.cartStrings ? cartStrings.error : 'Error');
      })
      .finally(function () {
        changing = false;
      });
  }

  function scopeOf(el) {
    return el.closest('cart-drawer') ? 'drawer' : 'page';
  }

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target;

    var bubble = t.closest('#cart-icon-bubble');
    if (bubble && drawerEl() && !isCartPage) {
      event.preventDefault();
      openDrawer(bubble);
      return;
    }

    if (t.id === 'CartDrawer-Overlay') {
      closeDrawer();
      return;
    }

    var qtyBtn = t.closest('quantity-input button');
    if (qtyBtn) {
      event.preventDefault();
      var wrap = qtyBtn.closest('quantity-input');
      var input = wrap.querySelector('input');
      var before = input.value;
      if (qtyBtn.name === 'plus') input.stepUp();
      else input.stepDown();
      if (before !== input.value) input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var remove = t.closest('cart-remove-button');
    if (remove) {
      event.preventDefault();
      changeLine(lineFrom(remove), 0, scopeOf(remove));
      return;
    }

    /* Oferta de dije: vive aqui porque su bloque se vuelve a pintar al cambiar el carrito */
    var dije = t.closest('[data-dije-add]');
    if (dije && !dije.disabled) {
      event.preventDefault();
      var label = dije.querySelector('.dije-offer__btn-label');
      var spin = dije.querySelector('.dije-offer__btn-spinner');
      var original = label ? label.textContent : '';
      dije.disabled = true;
      if (label) label.textContent = dije.dataset.adding || original;
      if (spin) spin.hidden = false;
      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(dije.dataset.variantId), quantity: 1 }] }),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add');
          return refreshCart();
        })
        .catch(function () {
          dije.disabled = false;
          if (label) label.textContent = window.cartStrings ? cartStrings.error : original;
          if (spin) spin.hidden = true;
        });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches || !input.matches('quantity-input input')) return;
    if (!input.closest('cart-items, cart-drawer-items')) return;
    changeLine(lineFrom(input), parseInt(input.value, 10) || 0, scopeOf(input));
  });

  document.addEventListener('keyup', function (event) {
    var drawer = drawerEl();
    if (event.code === 'Escape' && drawer && drawer.classList.contains('active')) closeDrawer();
  });

  /* ---------- Agregar al carrito ---------- */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      if (this.pulsmanReady) return;
      this.pulsmanReady = true;
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.querySelectorAll('input[name="id"]').forEach(function (i) {
        i.disabled = false;
      });
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    showError(message) {
      var wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      wrapper.hidden = !message;
      var text = wrapper.querySelector('.product-form__error-message');
      if (text) text.textContent = message || '';
    }

    onSubmit(event) {
      event.preventDefault();
      var self = this;
      var btn = this.querySelector('[type="submit"]');
      if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
      var idInput = this.querySelector('input[name="id"]');
      var skipCart = idInput && idInput.dataset.skipCart === 'true';
      var spinner = btn.querySelector('.loading-overlay__spinner');
      this.showError(null);
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      var body = new FormData(this.form);
      body.append('sections', 'cart-drawer,cart-icon-bubble');
      body.append('sections_url', location.pathname);

      fetch(routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) {
            self.showError(res.data.description || res.data.message || (window.cartStrings && cartStrings.error));
            return;
          }
          if (skipCart) {
            location.href = root + 'checkout';
            return;
          }
          if (isCartPage) return refreshCartPage();
          var sections = res.data.sections || {};
          if (sections['cart-drawer']) {
            applyDrawer(sections['cart-drawer']);
            applyBubble(sections['cart-icon-bubble']);
          } else {
            return refreshCart().then(function () {
              openDrawer(btn);
            });
          }
          openDrawer(btn);
        })
        .catch(function () {
          self.showError(window.cartStrings ? cartStrings.error : 'Error');
        })
        .finally(function () {
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }
  }

  /* ---------- Variantes ---------- */
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));
    }

    variants() {
      if (!this.variantData) {
        var json = this.querySelector('script[type="application/json"]');
        this.variantData = json ? JSON.parse(json.textContent) : [];
      }
      return this.variantData;
    }

    selectedOptions() {
      var options = [];
      this.querySelectorAll('.product-form__input').forEach(function (group) {
        var select = group.querySelector('select');
        var radio = group.querySelector('input[type="radio"]:checked');
        if (select) options.push(select.value);
        else if (radio) options.push(radio.value);
      });
      return options;
    }

    onChange() {
      var selected = this.selectedOptions();
      var variant = this.variants().find(function (v) {
        return v.options.every(function (o, i) {
          return o === selected[i];
        });
      });
      var sectionId = this.dataset.section;
      var scope = this.closest('product-info') || document;
      var form = scope.querySelector('product-form');
      var btn = form && form.querySelector('[type="submit"]');
      if (!variant) {
        if (btn) btn.disabled = true;
        return;
      }
      scope.querySelectorAll('input[name="id"]').forEach(function (i) {
        i.value = variant.id;
      });
      if (this.dataset.updateUrl !== 'false') {
        history.replaceState({}, '', this.dataset.url + '?variant=' + variant.id);
      }
      /* La foto de la variante, el precio y el boton salen de la propia seccion */
      var gallery = document.querySelector('media-gallery[id$="' + sectionId + '"]');
      if (variant.featured_media && gallery && gallery.setActiveMedia) {
        gallery.setActiveMedia(sectionId + '-' + variant.featured_media.id, true);
      }
      fetch(this.dataset.url + '?variant=' + variant.id + '&section_id=' + sectionId)
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var fresh = parse(html);
          ['price-' + sectionId].forEach(function (id) {
            var a = document.getElementById(id);
            var b = fresh.getElementById(id);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          var freshBtn = fresh.getElementById('ProductSubmitButton-' + sectionId);
          if (btn && freshBtn) {
            btn.disabled = freshBtn.disabled;
            var a = btn.querySelector('.main-atc__label');
            var b = freshBtn.querySelector('.main-atc__label');
            if (a && b) a.innerHTML = b.innerHTML;
          }
          var incl = document.querySelector('.incl');
          var freshIncl = fresh.querySelector('.incl');
          if (incl && freshIncl) incl.innerHTML = freshIncl.innerHTML;
        });
    }
  }

  /* ---------- Cupon ---------- */
  window.handleDiscountFormChange = function (event) {
    var form = event.target.closest('form');
    var error = form && form.querySelector('.cart-discount-form__error');
    if (error) error.style.display = 'none';
  };

  window.handleDiscountForm = function (event) {
    event.preventDefault();
    var form = event.target;
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    var error = form.querySelector('.cart-discount-form__error');
    var emptyMessage = error ? error.textContent : '';
    if (!code) {
      if (error) error.style.display = 'block';
      return;
    }
    var btn = form.querySelector('button');
    if (btn) btn.disabled = true;
    function setDiscount(value) {
      return fetch(routes.cart_update_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: value }),
      }).then(function (r) {
        return r.json();
      });
    }
    var previous = '';
    fetch(cartUrl + '.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        previous = (cart.discount_codes || [])
          .filter(function (d) {
            return d.applicable;
          })
          .map(function (d) {
            return d.code;
          })
          .join(',');
        return setDiscount(code);
      })
      .then(function (cart) {
        var match = (cart.discount_codes || []).find(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        });
        var applied = !!(match && match.applicable);
        /* Un codigo invalido no se queda pegado al carrito ni borra el que ya servia */
        return (applied ? Promise.resolve() : setDiscount(previous)).then(refreshCart).then(function () {
          var freshForm = document.querySelector('.cart-discount-form');
          if (!freshForm) return;
          var freshInput = freshForm.querySelector('input');
          var freshError = freshForm.querySelector('.cart-discount-form__error');
          if (applied) {
            if (freshInput) freshInput.value = '';
            return;
          }
          if (freshInput) freshInput.value = code;
          if (freshError) {
            freshError.textContent = 'Ese código no es válido para este pedido';
            freshError.style.display = 'block';
          }
        });
      })
      .catch(function () {
        if (error) {
          error.textContent = window.cartStrings ? cartStrings.error : emptyMessage;
          error.style.display = 'block';
        }
      })
      .finally(function () {
        if (btn) btn.disabled = false;
      });
  };

  /* ---------- Registro ---------- */
  function define(name, ctor) {
    if (!customElements.get(name)) customElements.define(name, ctor);
  }
  define('cart-drawer', CartDrawer);
  define('product-form', ProductForm);
  define('variant-selects', VariantSelects);
  ['cart-drawer-items', 'cart-items', 'cart-remove-button', 'quantity-input', 'product-info'].forEach(function (name) {
    define(name, class extends HTMLElement {});
  });

  tickTimers();
  document.addEventListener('DOMContentLoaded', tickTimers);
})();
